export default __webpack_public_path__ + "static/media/NewLogoCW.ecfb54bb.svg";